module.exports = __webpack_public_path__ + "static/media/toaster-trashbin.88878198.svg";